import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthWrapper from "../../layout/AuthWrapper";
import { Button, Form, Input, Textarea } from "../../styles";
import Api from "../../api/axios";
import { useUserContext } from "../../context/user_context";
import { useLocalStorage } from "../../utils/useLocalStorage";
import { encrypt } from "../../encrypt";
import { form } from "../../assets";

function CreateBizProfile() {


  const [sending, setsending] = useState(false);
  const [bizData, setBizData] = useLocalStorage('businessData');
  const [storeData, setStoreData] = useLocalStorage('storeData');

  let navigate = useNavigate();
  const { usertoken } = useUserContext();


  // Form Fields
  const [formField, setformField] = useState({ name: '', bmail: '', address: '', phone: '', no_workers: '', description: '', sname: '', slocation: '' });

  function handleChange(e) {
    setformField((Inputs) => ({
      ...Inputs,
      [e.target.name]: e.target.value,
    }));
  }
  // Form Fields

  //   Setup Business Function
  //   Setup Business Function
  function setupCompany(e) {
    e.preventDefault();
    if (formField.name && formField.bmail && formField.address && formField.phone && formField.no_workers && formField.description && formField.sname) {
      setsending(true);

      const data = {
        name: formField.name,
        bmail: formField.bmail,
        address: formField.address,
        phone: formField.phone,
        no_workers: formField.no_workers,
        description: formField.description,

        storename: formField.sname,
        location: formField.slocation,

        usertoken,
      };

      Api.post(`/createBusinessWithStore`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setsending(false);
          } else {
            setsending(false);
            navigate("/login");
            setBizData(encrypt(res.data.businessData));
            setStoreData(encrypt(res.data.storeData));
            setTimeout(() => {
              toast.success(res.message);
              toast.success(`Please, login again.`);
            }, 10);
          }
        })
        .catch((error) => {
          setsending(false);
        });
    } else {
      setsending(false);
      toast.warn("Empty Fields !!!");
    }
  }
  //   Setup Business Function
  //   Setup Business Function

  return (
    <>

      <AuthWrapper
        title='Create a Business'
        subTitle='Create your business to begin your journey.'
        img={form}
      >
        <Form onSubmit={(e) => setupCompany(e)}
        >
          <div className="row justify-content-center text-left">
            <div className="col-md-12 ">
              <label className="mb-0">Business Name:</label>
              <Input
                type="text"
                name="name"
                placeholder="e.g. Fireswitch ltd"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-12 ">
              <label className="mb-0"> Phone Number:</label>
              <Input
                type="number"
                name="phone"
                placeholder="080123456789"
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-12 ">
              <label className="mb-0"> Business Email:</label>
              <Input
                type="email"
                name="bmail"
                placeholder="work@mail.com"
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-12 ">
              <label className="mb-0"> Number of workers:</label>
              <Input
                type="text"
                name="no_workers"
                placeholder="e.g. 15"
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-12 ">
              <label className="mb-0"> Business Address:</label>
              <Textarea
                type="text"
                name="address"
                placeholder="Address"
                onChange={handleChange}
                required
                autoComplete="false"
              />
            </div>
            <div className="col-md-12 ">
              <label className="mb-0"> Business Description:</label>
              <Textarea
                type="text"
                name="description"
                className="Input-style textarea-style"
                placeholder="e.g. We are a Tech Company in Ibadan"
                onChange={handleChange}
                required
              />
            </div>

            <hr className="border-gray w-100" />
            <div className="text-center mb-5 pry-text">
              <h5>Add a Store / Branch</h5>
              <small>Your Business needs to have a Store / Branch.</small>

            </div>

            <div className="col-md-12 ">
              <label className="mb-0">Store Name:</label>
              <Input
                type="text"
                name="sname"
                placeholder="e.g. Reni Store"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-12 ">
              <label className="mb-0"> Store Location:</label>
              <Textarea
                type="text"
                name="slocation"
                placeholder="Store Location"
                onChange={handleChange}
                autoComplete="false"
              />
            </div>

            <div className="col-md-12 mx-auto text-center">
              <Button
                pry
                type="submit"
                disabled={sending}
                className="btn m-0 w-100"  >
                {sending ? 'loading...' : "Submit"}
              </Button>
              <div className="text-center mt-4">
                <small>
                  {" "}
                  By clicking the button above, you agree to our{" "}
                  <span className="pry-text">
                    <Link>Terms & Conditions</Link>
                  </span>{" "}
                  and{" "}
                  <span className="pry-text">
                    <Link>Privacy Policy </Link>
                  </span>{" "}
                  .
                </small>
              </div>
            </div>
          </div>
        </Form>
      </AuthWrapper>
    </>
  );
}

export default CreateBizProfile;
